"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var form_store_1 = __importDefault(require("../stores/form_store"));
var input_actions_1 = __importDefault(require("../actions/input_actions"));
;
;
var AfterBirthOption = /** @class */ (function (_super) {
    __extends(AfterBirthOption, _super);
    function AfterBirthOption(props) {
        var _this = _super.call(this, props) || this;
        _this.key = "";
        _this.state = {
            value: "",
            error: []
        };
        _this._isMounted = false;
        form_store_1.default.on('STATE_CHANGE', function () {
            var number = _this.props.number;
            if (_this._isMounted) {
                var state = form_store_1.default.getState();
                _this.setState({
                    val1: state.data["after_birth_option_year_".concat(number)],
                    val2: state.data["after_birth_option_month_".concat(number)],
                    val3: state.data["after_birth_option_day_".concat(number)],
                    error1: state.error["after_birth_option_year_".concat(number)],
                    error2: state.error["after_birth_option_month_".concat(number)],
                    error3: state.error["after_birth_option_day_".concat(number)],
                });
            }
        });
        return _this;
    }
    AfterBirthOption.prototype.componentDidMount = function () {
        var number = this.props.number;
        this.key = "after_birth_option_year_".concat(number);
        this._isMounted = true;
        var state = form_store_1.default.getState();
        this.setState({
            val1: state.data["after_birth_option_year_".concat(number)],
            val2: state.data["after_birth_option_month_".concat(number)],
            val3: state.data["after_birth_option_day_".concat(number)],
            error1: state.error["after_birth_option_year_".concat(number)],
            error2: state.error["after_birth_option_month_".concat(number)],
            error3: state.error["after_birth_option_day_".concat(number)],
        });
    };
    AfterBirthOption.prototype.componentWillUnmount = function () {
        this._isMounted = false;
    };
    AfterBirthOption.prototype.render = function () {
        var number = this.props.number;
        var errorElem = (react_1.default.createElement(react_1.default.Fragment, null));
        var errors = new Array().concat(this.state.error1, this.state.error2, this.state.error3);
        if (errors.length > 0) {
            errorElem = (react_1.default.createElement("p", { className: "form-error" }, errors[0]));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            errorElem,
            react_1.default.createElement("p", { className: "form__note" }, "\u6B7B\u4EA1\u6708\u65E5(\u897F\u66A6)"),
            react_1.default.createElement("div", { className: "input-date" },
                react_1.default.createElement("div", { className: "input-date__box" },
                    react_1.default.createElement("input", { className: "input-text input-date__year", type: "text", name: "after_birth_option_year_".concat(number), onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput, value: this.state.val1 }),
                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u5E74")),
                react_1.default.createElement("div", { className: "input-date__box" },
                    react_1.default.createElement("input", { className: "input-text input-date__short", type: "text", name: "after_birth_option_month_".concat(number), onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput, value: this.state.val2 }),
                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u6708")),
                react_1.default.createElement("div", { className: "input-date__box" },
                    react_1.default.createElement("input", { className: "input-text input-date__short", type: "text", name: "after_birth_option_day_".concat(number), onChange: input_actions_1.default.changeInput, onBlur: input_actions_1.default.changeInput, value: this.state.val3 }),
                    react_1.default.createElement("span", { className: "input-date__sep" }, "\u65E5")))));
    };
    return AfterBirthOption;
}(react_1.Component));
exports.default = AfterBirthOption;
